import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal, {
  IStoreWithModal,
  xcriticalModalClose,
  getModalByName,
} from '@xcritical/modal';

import { IsHorizontalContext } from '@crm-lead/base';

import { LEAD_PREVIEW_MODAL } from '../consts';

const getPreviewModal = (state: IStoreWithModal) =>
  getModalByName(state, LEAD_PREVIEW_MODAL);

export const PreviewModal: React.FC = () => {
  const isHorizontal = useContext(IsHorizontalContext);

  const dispatch = useDispatch();

  const { isOpen, value } = useSelector(getPreviewModal);

  const onCloseModal = useCallback(() => {
    dispatch(xcriticalModalClose(LEAD_PREVIEW_MODAL));
  }, []);

  return (
    <Modal
      appearance={isHorizontal ? 'previewHorizontalModal' : 'previewModal'}
      name={LEAD_PREVIEW_MODAL}
      title="Description"
      minHeight="200px"
      maxHeight="600px"
      isOpen={isOpen}
      onModalCancel={onCloseModal}>
      {value}
    </Modal>
  );
};
